import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=33b50948&scoped=true&"
import script from "./ConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationModal.vue?vue&type=style&index=0&id=33b50948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b50948",
  null
  
)

export default component.exports